<script lang="ts" setup>
import { computed } from 'vue';
import { Validation } from '@vuelidate/core';

const props = defineProps<{
  label?: string,
  required?: boolean,
  validation?: Validation,
  showError?: boolean,
}>();

const isError = computed(() => props.validation?.$error);

const errorText = computed(() => (
  props.validation?.$errors?.map(error => error.$message)
    .join('. ') || ''

));
</script>

<template>
  <div class="BaseFormGroup base-form-group">
    <label
      v-if="label"
      class="base-form-group__label"
    >
      <span class="base-form-group__label-text">{{ label }}</span>
      <span
        v-if="required"
        class="base-form-group__label-required"
      >*</span>
    </label>
    <div class="base-form-group__input">
      <slot
        :is-field-error="isError"
        :field-error-text="errorText"
      />
    </div>
    <div
      v-if="isError || showError"
      class="base-form-group__error"
    >
      <template v-if="showError">
        <slot
          name="error"
          :error-text="errorText"
        />
      </template>
      <template v-else-if="isError">
        {{ errorText }}
      </template>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~Styles/_variables'
.base-form-group
  display: flex
  flex-direction: column
  position: relative

  &__label
    color: $gray-70
    +font(500)
    font-size: 14px
    display: inline-block
    line-height: 18px
    margin-bottom: 8px
    position: relative

  &__label-link
    position: absolute
    right: 0
    top: 0

  &__label-required
    color: $support_red

  &__error
    font-size: 12px
    +font(400)
    line-height: 17px
    margin-top: 4px
    color: $support_red

  &__input
    width: 100%
</style>
